import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">更新动态</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">实时追踪</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {updates.map((item) => {
            const tagBg = item.tagColor === 'primary' ? 'bg-primary-100 text-primary-700' : item.tagColor === 'accent' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700';
            return (
              <div key={item.id} className="flex items-start gap-3 p-4 rounded-lg bg-background-50 hover:bg-background-50/80 transition-colors cursor-pointer group">
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap mt-0.5">{item.date}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed line-clamp-2">{item.title}</p>
                </div>
                <span className={`shrink-0 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagBg}`}>{item.tag}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}